import React from 'react';
import { useDropdown } from '../Dropdown';
import Arrow from '../../../visuals/Icons/Arrow';
import { useTranslations } from 'next-intl';

export const Trigger: React.FC = () => {
  const tCatalog = useTranslations('Catalog');
  const {
    label,
    dropdownItems,
    selectedItemsCount = 0,
    setIsExpended,
    isExpended,
  } = useDropdown();

  return (
    <button
      onClick={() => setIsExpended(!isExpended)}
      className={`
          tw-lf-button-clear
          tw-appearance-none
          tw-h-10
          tw-left-0
          tw-top-0
          tw-rounded-lg
          tw-border
          tw-border-solid
          ${isExpended ? 'tw-border-blue-600' : 'tw-border-blue-200'}
          tw-bg-white
          tw-flex
          tw-items-center
          tw-px-4
          tw-py-2.5
          tw-h-11
        `}
      disabled={dropdownItems.length === 0}
    >
      <span className={`tw-lf-body-regular-md`}>{label}</span>
      {selectedItemsCount > 0 ? (
        <span
          className={`
              tw-lf-counter-badge
              tw-lf-counter-badge-accent
              tw-lf-caption-strong
              tw-ml-2
            `}
        >
          {selectedItemsCount}{' '}
          <span className="sr-only">{tCatalog('selectedFiltersCount')}</span>
        </span>
      ) : null}
      <div className="tw-ml-3">
        <Arrow
          headDirection={isExpended ? 'top' : 'bottom'}
          width={7}
          height={13}
        />
      </div>
    </button>
  );
};
